<section class="tech-table-info-header">
  <div class="close-icon">
    <fa-icon
      [icon]="['fas', 'chevron-left']"
      size="lg"
      class="blue-dark"
      (click)="onClose()"
    ></fa-icon>
  </div>
  <div class="title blue-dark">
    {{ data.title }}
  </div>
  <fa-icon
    *ngIf="favoritesonPortal && data.isFavourite !== null && data.isFavourite !== undefined"
    class="pointer favorite"
    size="lg"
    (click)="changeFavourite($event)"
    [icon]="[data.isFavourite ? 'fas' : 'fal', 'star']"
  ></fa-icon>
</section>
<section class="tech-table-info">
  <mat-tab-group
    *ngIf="data.items && urlTReport; else oneTab"
    mat-stretch-tabs="true"
    mat-align-tabs="center"
  >
    <mat-tab label="{{ 'k003425' | translate }}">
      <ng-template matTabContent>
        <section class="tech-table-info-details">
          <div class="item" *ngFor="let item of data.items">
            <div class="label">{{ item.label | translate }}</div>
            <div class="value">{{ item.value }}</div>
          </div>
        </section>
      </ng-template>
    </mat-tab>
    <mat-tab label="{{ 'k003427' | translate }}">
      <ng-template matTabContent>
        <section class="tech-table-info-iframe">
          <iframe [src]="urlTReport | trSafeResourceUrl"></iframe></section
      ></ng-template>
    </mat-tab>
  </mat-tab-group>
  <ng-template #oneTab>
    <!-- Show data -->
    <ng-container *ngIf="data.items">
      <section class="tech-table-info-details">
        <div class="item" *ngFor="let item of data.items">
          <div class="label">{{ item.label | translate }}</div>
          <div class="value">{{ item.value }}</div>
        </div>
      </section>
    </ng-container>
    <!-- Show TReport -->
    <ng-container *ngIf="urlTReport">
      <section class="tech-table-info-iframe">
        <iframe [src]="urlTReport | trSafeResourceUrl"></iframe>
      </section>
    </ng-container>
  </ng-template>
</section>
